import React from "react";
import moment from "moment";
import ArrowKeysReact from "arrow-keys-react";

export default class TextInput extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			value: this.props.value,
			dateTime: moment("01/01/2020 " + this.props.value, "DD/MM/yyyy HH:mm"),
		};

		ArrowKeysReact.config({
			right: () => {
				var updatedDate = moment(this.state.dateTime).add(15, "minutes");
				var value = moment(updatedDate).format("HH:mm");
				this.setState({ value: value, dateTime: updatedDate });
				this.props.onChange(value);
			},
			left: () => {
				var updatedDate = moment(this.state.dateTime).add(-15, "minutes");
				var value = moment(updatedDate).format("HH:mm");
				this.setState({ value: value, dateTime: updatedDate });
				this.props.onChange(value);
			},
		});
	}

	handleChange(event) {
		let inputValue = event.target.value;

		if (this.props.time) {
			// Rimuove tutti i caratteri non numerici
			inputValue = inputValue.replace(/[^0-9]/g, "");

			// Aggiunge i due punti dopo i primi due numeri
			if (inputValue.length > 2) {
				inputValue = inputValue.slice(0, 2) + ":" + inputValue.slice(2);
			}

			// Limita la lunghezza massima a 5 caratteri (HH:MM)
			if (inputValue.length > 5) {
				inputValue = inputValue.slice(0, 5);
			}
		}

		this.setState({ value: inputValue });
		if (this.props.onChange) {
			this.props.onChange(inputValue);
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.value !== this.props.value) {
			this.setState({ value: this.props.value });
		}
	}

	render() {
		const passwordFlag = this.props.type === "password";
		const readOnly = this.props.readOnly === true;

		if (readOnly) {
			return (
				<div {...ArrowKeysReact.events} style={mainClass}>
					<div style={name}>{this.props.name}</div>
					<input
						autoFocus
						type={passwordFlag ? "password" : "text"}
						style={inputTextDisabled}
						readOnly
						value={this.state.value || this.props.value}
						onChange={this.handleChange.bind(this)}
					/>
				</div>
			);
		}

		return (
			<div style={mainClass}>
				<div style={name}>{this.props.name}</div>
				<input
					type={passwordFlag ? "password" : "text"}
					style={inputText}
					value={this.state.value || this.props.value}
					onChange={this.handleChange.bind(this)}
				/>
			</div>
		);
	}
}

const mainClass = {
	padding: "5px",
};

const name = {};

const inputText = {
	width: "300px",
	padding: "10px",
};

const inputTextDisabled = {
	background: "#eeeeee",
	width: "300px",
	padding: "10px",
};
